let get_refresh_list = function() {
	if (this.get_refresh_list) {
		this.getJobsDash();
		this.$store.commit("ModApps/jobs/set_refresh_list", false);
	}
};
export default get_refresh_list;
